import { useRef } from "react";
import { motion } from "framer-motion";

const HorizontalScroller = ({ children, title }) => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { current } = scrollRef;
      // Dynamically calculate scroll amount based on first child width (or fallback to 300)
      const child = current.children[0];
      const scrollAmount = child ? child.clientWidth + 24 : 300; // 24 is gap-6 (1.5rem = 24px)
      current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="relative group">
      {/* Optional title for the scroller */}
      {title && (
        <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b-2 border-blue-800 pb-1 inline-block">
          {title}
        </h3>
      )}

      {/* Scroll buttons – more subtle, accessible design */}
      <button
        onClick={() => scroll("left")}
        className="absolute left-0 top-1/2 -translate-y-1/2 z-20 bg-white border border-gray-300 text-blue-900 rounded-r-md px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity shadow-sm hover:bg-blue-50 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
        aria-label="Scroll left"
      >
        ←
      </button>


      <button
        onClick={() => scroll("right")}
        className="absolute right-0 top-1/2 -translate-y-1/2 z-20 bg-white border border-gray-300 text-blue-900 rounded-l-md px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity shadow-sm hover:bg-blue-50 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
        aria-label="Scroll right"
      >
        →
      </button>

      {/* Fade edges – very subtle, using official colors */}
      {/* <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-white via-white to-transparent z-10 pointer-events-none"></div>
      <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-white via-white to-transparent z-10 pointer-events-none"></div> */}

      {/* Scrollable container with a panel-like appearance */}
      <div
        ref={scrollRef}
        className="flex overflow-x-auto gap-6 pb-4 pt-2 px-1  border rounded-lg "
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {children}
      </div>

      {/* Subtle scroll hint (optional) */}
      <div className="text-xs text-gray-400 mt-2 text-right">
        Scroll for more →
      </div>
    </div>
  );
};

export default HorizontalScroller;